import { createFileRoute } from '@tanstack/react-router';
import { toolHead } from '../../../lib/toolHead';
import { UsernameCheckerPage } from '../../../pages/tools/creator-tools/UsernameCheckerPage';

export const Route = createFileRoute('/_site/tools/username-checker')({
  head: () => toolHead('username-checker'),
  component: UsernameCheckerPage,
});
